import {
  AGENT,
  BRANCH,
} from '@/components/FilterBar/constants/filtersConstants';
import { PROPERTIES_STATUS } from '../../constants';

export function getRemainingDays(isoDate) {
  const targetDate = new Date(isoDate);
  const today = new Date();

  const utcTarget = Date.UTC(
    targetDate.getFullYear(),
    targetDate.getMonth(),
    targetDate.getDate()
  );
  const utcToday = Date.UTC(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  const diffMilliseconds = utcTarget - utcToday;
  const diffDays = Math.floor(diffMilliseconds / (1000 * 60 * 60 * 24));

  return diffDays;
}

export function getVisitScheduleDisplay(
  when,
  todayLabel,
  userLocale = 'es-AR'
) {
  const date = new Date(when);
  const time = date.toLocaleTimeString(userLocale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  if (getRemainingDays(when) === 0) {
    return `${todayLabel} ${time}`;
  }

  const day = date.toLocaleDateString(userLocale, {
    day: '2-digit',
    month: '2-digit',
  });

  return `${day} ${time}`;
}

export function getContactCardData(entity) {
  if (!entity) return null;
  const {
    id = null,
    name = '',
    email = '',
    profile_picture_url = '',
    is_valid_cellphone = false,
    lead_status = null,
    agent = null,
  } = entity;

  const { name: leadStatus, color } = lead_status || {};
  const { agent: agent_name, agent_id } = agent || {};
  const agentId = agent_id || agent?.id || null;
  const agentName = agent_name || agent?.name || null;
  return {
    id,
    name,
    email,
    profilePicture: profile_picture_url,
    isValidCellphone: is_valid_cellphone,
    leadStatus,
    leadStatusColor: color,
    agentName,
    agentId,
  };
}

export function getAgentCardData(entity) {
  if (!entity) return null;
  const {
    id = null,
    name = '',
    branch_name = '',
    profile_picture_url = '',
  } = entity;
  return {
    id,
    name,
    branchName: branch_name,
    profilePicture: profile_picture_url,
  };
}

export function showCardSeparator(index, array) {
  const maxRowToShow = 4;
  if (index < array.length - 1 && index < maxRowToShow - 1) return true;
  return false;
}

export const showRemainingEntitiesCard = (array) => {
  const maxRowToShow = 4;
  if (array.length > maxRowToShow) return true;
  return false;
};

export const getAgeForParams = (min, max) => {
  // [["age",">",24],["age","<",51]]
  const filters = [];

  if (typeof min === 'number') {
    filters.push(['age', '>', min]);
  }
  if (typeof max === 'number') {
    filters.push(['age', '<', max]);
  }

  return filters;
};

export const getStatusForParams = (statusId) => {
  if (!statusId) return {};

  const statuses = {
    [PROPERTIES_STATUS.AVAILABLE]: 'only_available',
    [PROPERTIES_STATUS.RESERVED]: 'only_reserved',
    [PROPERTIES_STATUS.APPRAISAL]: 'only_to_be_cotized',
    [PROPERTIES_STATUS.NOT_AVAILABLE]: 'only_not_available',
  };

  const selectedStatus = {
    [statuses[statusId]]: 'checked',
  };

  return selectedStatus;
};

export const getEntityFiltersForParams = (selectedIds) => {
  const entityFilters = [];

  if (selectedIds.length > 0) {
    const producerKey = 'producer_user__id';
    const branchKey = 'branch__id';
    const options = {
      [AGENT]: producerKey,
      [BRANCH]: branchKey,
    };

    entityFilters.push([
      options[selectedIds[0].filter_type],
      'op',
      selectedIds[0].id.toString(),
    ]);
  }

  return entityFilters;
};

export const getPropertiesSearchParams = (paramsToOverride) => {
  const {
    statusId,
    ageMin = null,
    ageMax = null,
    selectedIds = [],
    ...restOfParams
  } = paramsToOverride;

  const defaultSearchOptions = {
    filters: [],
    only_available: 'undefined',
    only_reserved: 'undefined',
    only_to_be_cotized: 'undefined',
    only_not_available: 'undefined',
    with_tags: [],
    without_tags: [],
    with_custom_tags: [],
    with_or_custom_tags: [],
    without_custom_tags: [],
    listing_edition_review: [],
    division_filters: [],
    state_filters: [],
    current_localization_id: '',
    current_localization_type: '',
    network: [],
    price_from: '0',
    price_to: '9999999999',
    operation_types: [],
    property_types: [],
    currency: 'USD',
    bounding_box: [],
  };

  const statusToCheck = getStatusForParams(statusId);
  const ageFilters = getAgeForParams(ageMin, ageMax);
  const entityFilters = getEntityFiltersForParams(selectedIds);

  const searchOptions = {
    ...defaultSearchOptions,
    ...restOfParams,
    ...statusToCheck,
    filters: [...defaultSearchOptions.filters, ...ageFilters, ...entityFilters],
  };

  return encodeURIComponent(JSON.stringify(searchOptions));
};
